import { defineMessages } from 'react-intl';

export default defineMessages({
    hidePackageCoverages: {
        id: 'policy.common.component.farm-policy-info.hide vehicle coverages',
        defaultMessage: 'Hide Package Coverages'
    },
    showPackageCoverages: {
        id: 'policy.common.component.farm-policy-info.show vehicle coverages',
        defaultMessage: 'Show Package Coverages'
    },
    package: {
        id: 'policy.common.component.farm-policy-info.Package',
        defaultMessage: 'Package'
    },
    primary: {
        id: 'policy.common.component.farm-policy-info.Primary',
        defaultMessage: 'Primary'
    },
    supremeAgribusiness: {
        id: 'policy.common.component.farm-policy-info.Supreme Agribusiness',
        defaultMessage: 'Supreme Agribusiness'
    },
    nonPackagedAgribusiness: {
        id: 'policy.common.component.farm-policy-info.Non Packaged Agribusiness',
        defaultMessage: 'Non Packaged Agribusiness'
    },
    PackageType: {
        id: 'policy.common.component.farm-policy-info.Package Type',
        defaultMessage: 'Package Type'
    },
    farmProgramType: {
        id: 'policy.common.component.farm-policy-info.Farm Program Type',
        defaultMessage: 'farmProgramType'
    },
    taxExempt: {
        id: 'policy.common.component.farm-policy-info.Tax Exempt',
        defaultMessage: 'Tax Exempt'
    },
    fireGrade: {
        id: 'policy.common.component.farm-policy-info.Fire Grade',
        defaultMessage: 'Fire Grade'
    },
    discounts: {
        id: 'policy.common.component.farm-policy-info.Discounts',
        defaultMessage: 'Discounts'
    },
    programCoveragesEndorsements: {
        id: 'policy.common.component.farm-policy-info.Program Coverages/ Endorsements',
        defaultMessage: 'Program Coverages/ Endorsements'
    },
    limit: {
        id: 'policy.common.component.farm-policy-info.Limit',
        defaultMessage: 'Limit'
    },
    deductible: {
        id: 'policy.common.component.farm-policy-info.Deductible',
        defaultMessage: 'Deductible'
    },
    businessInterruption: {
        id: 'policy.common.component.farm-policy-info.Business Interruption',
        defaultMessage: 'Business Interruption'
    },
    coverage: {
        id: 'policy.common.component.farm-policy-info.Coverage',
        defaultMessage: 'Coverage'
    },
    equipmentandMachinery: {
        id: 'policy.common.component.farm-policy-info.Equipment and Machinery',
        defaultMessage: 'Equipment and Machinery'
    },
    buildings: {
        id: 'policy.common.component.farm-policy-info.Buildings',
        defaultMessage: 'Buildings'
    },
    produce: {
        id: 'policy.common.component.farm-policy-info.Produce',
        defaultMessage: 'Produce'
    },
    produceDetails: {
        id: 'policy.common.component.farm-policy-info.Produce Details',
        defaultMessage: 'Produce Details'
    },
    livestock: {
        id: 'policy.common.component.farm-policy-info.Livestock',
        defaultMessage: 'Livestock'
    },
    classification: {
        id: 'policy.common.component.farm-policy-info.Classification',
        defaultMessage: 'Classification'
    },
    farmExtensions: {
        id: 'policy.common.component.farm-policy-info.Farm Extensions',
        defaultMessage: 'FarmExtensions'
    },
    value: {
        id: 'policy.common.component.farm-policy-info.Value',
        defaultMessage: 'Value'
    },
    coveragesEmpty: {
        id: 'policy.common.component.farm-policy-info.CoveragesEmpty',
        defaultMessage: 'CoveragesEmpty'
    }, 
    agriculturalBuildings: {
        id: 'policy.common.component.farm-policy-info.Agricultural Buildings',
        defaultMessage: 'Agricultural Buildings'
    },
    occupancyType: {
        id: 'policy.farm.directives.outBuilding.Occupancy Type',
        defaultMessage: 'Occupancy Type'   
    } ,
    yearBuilt: {
        id: 'policy.farm.directives.outBuilding.Year Built',
        defaultMessage: 'Year Built'   
    },
    majorUsageClass1: {
        id: 'policy.farm.directives.outBuilding.Major Usage Class 1',
        defaultMessage: 'Major Usage Class 1'   
    },
    majorUsageClass2: {
        id: 'policy.farm.directives.outBuilding.Major Usage Class 2',
        defaultMessage: 'Major Usage Class 2'   
    },
    hideOutBuildingCoverages:{
        id:'policy.farm.directives.outBuilding.Hide Building Coverages',
        defaultMessage: 'Hide Building Coverages'
    },
    showOutBuildingCoverages:{
        id:'policy.farm.directives.outBuilding.Show Building Coverages',
        defaultMessage: 'Show Building Coverages'
    },
    hideFarmCoverages:{
        id:'policy.farm.directives.farm-coverage-info.Hide Coverages',
        defaultMessage: 'Hide Coverages'
    },
    showFarmCoverages:{
        id:'policy.farm.directives.farm-coverage-info.Show Coverages',
        defaultMessage: 'Show Coverages'
    },
    noFarmOutBuildingsCoveragesAvailable: {
        id: 'policy.farm.directives.policy-coverage-info.No Farm Outbuildings Coverages available',
        defaultMessage: 'No Farm Outbuildings Coverages available'
    },
    heating : {
        id:'policy.farm.directives.farm-coverage-info.Heating',
        defaultMessage: 'Heating'
    },
    evaluator : {
        id:'policy.farm.directives.farm-coverage-info.Evaluator',
        defaultMessage: 'Evaluator'
    },
    estimatedReplacementCost : {
        id:'policy.farm.directives.farm-coverage-info.Estimated Replacement Cost',
        defaultMessage: 'Estimated Replacement Cost'
    },
    evaluationDate : {
        id:'policy.farm.directives.farm-coverage-info.Evaluation Date',
        defaultMessage: 'Evaluation Date'
    },
    name : {
        id:'policy.farm.directives.farm-additional-interests.Name',
        defaultMessage: 'Name'
    },
    interestType : {
        id:'policy.farm.directives.farm-additional-interests.Interest Type',
        defaultMessage: 'Interest Type'
    },
    scheduleItem : {
        id:'policy.farm.directives.farm-additional-interests.Schedule Item',
        defaultMessage: 'Schedule Item'
    },
    additionalInterests: {
        id:'policy.farm.directives.farm-additional-interests.Additional Interests',
        defaultMessage: 'Additional Interests'
    }

});
